var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 13.3332H9.33329C12 13.3332 13.3333 11.9998 13.3333 9.33317V6.6665C13.3333 3.99984 12 2.6665 9.33329 2.6665H6.66663C3.99996 2.6665 2.66663 3.99984 2.66663 6.6665V9.33317C2.66663 11.9998 3.99996 13.3332 6.66663 13.3332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 13.3332H25.3333C28 13.3332 29.3333 11.9998 29.3333 9.33317V6.6665C29.3333 3.99984 28 2.6665 25.3333 2.6665H22.6666C20 2.6665 18.6666 3.99984 18.6666 6.6665V9.33317C18.6666 11.9998 20 13.3332 22.6666 13.3332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 29.3332H25.3333C28 29.3332 29.3333 27.9998 29.3333 25.3332V22.6665C29.3333 19.9998 28 18.6665 25.3333 18.6665H22.6666C20 18.6665 18.6666 19.9998 18.6666 22.6665V25.3332C18.6666 27.9998 20 29.3332 22.6666 29.3332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 29.3332H9.33329C12 29.3332 13.3333 27.9998 13.3333 25.3332V22.6665C13.3333 19.9998 12 18.6665 9.33329 18.6665H6.66663C3.99996 18.6665 2.66663 19.9998 2.66663 22.6665V25.3332C2.66663 27.9998 3.99996 29.3332 6.66663 29.3332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory1);
export default __webpack_public_path__ + "static/media/category (1).15744f6c953b5d354e93ac2e638ab7c4.svg";
export { ForwardRef as ReactComponent };